import {
  laravelGet,
  laravelPost,
  laravelPut,
  laravelDelete,
} from '../utils/laravelClient';

const AUTH = { auth: 'admin' };

export const fetchCategories = (page = 1, perPage) =>
  laravelGet('/categories', {
    ...AUTH,
    params: { page, ...(perPage ? { per_page: perPage } : {}) },
  });

export const createCategory = (category) =>
  laravelPost('/categories', category, AUTH);

export const updateCategory = (id, category) =>
  laravelPut(`/categories/${id}`, category, AUTH);

export const deleteCategory = (id) =>
  laravelDelete(`/categories/${id}`, AUTH);

/**
 * Fetch categories with their drinks for the public site.
 * Calls: GET /categories/with-drinks
 */
export const fetchCategoriesWithDrinks = async () => {
  const data = await laravelGet('/categories/with-drinks', { auth: 'none' });
  if (data && Array.isArray(data.categories)) return data.categories;
  return data;
};
